import { useState} from "react";
import "./index.css"
import About from "./Components/About";
import ARAbout from "./Components/AR/ArAbout.js";
import Contact from "./Components/Contact";
import Ausbildung from "./Components/Ausbildung";
import ArAusbildung from "./Components/AR/ArAusbildung";
import Berufstaetigkeit from "./Components/Berufstaetigkeit";
import ArBerufstaetigkeit from "./Components/AR/ARBerufstaetigkeit.js";
import Kenntnisse from "./Components/Kenntnisse";
import ARKenntnisse from "./Components/AR/ARKenntnisse.js";
import Praktikum from "./Components/Praktikum";
import ARPraktikum from "./Components/AR/ArPraktikum.js";
import Footer from "./Components/Footer";
import Image from "./Components/Image";
import ARImage from "./Components/AR/ArImage.js";
import Getkey from "./Components/Getkey";
import Translate from "./Components/Translate";


function  App() {
 
const [keyheader,setKeyheader]=useState("");
const [isValid,setIsValid]=useState(false);
const [lang,setLang]=useState({label:"Deutsch",value:"de"});
 const creatKey=(key)=>{
  
     setKeyheader(key);
     setIsValid(true);
   
}
const SelectedLang =(lang)=>{setLang(lang);};
switch(lang.value){
  case "ar": {
    if (isValid) {

      return(<div>
       <ARImage />
      <Contact Headerkey={keyheader}  />
        <ArAusbildung Headerkey={keyheader} />
        <ArBerufstaetigkeit Headerkey={keyheader} />
        <ARKenntnisse Headerkey={keyheader} /> 
        <ARPraktikum Headerkey={keyheader}  /> 
        <ARAbout  Headerkey={keyheader}  />
        <Footer />
       
        
    </div>)
     }
     else{
       return(<div> <Translate onSelected={SelectedLang}> </Translate> <ARImage></ARImage>	 <Getkey onSubmit={creatKey}  /></div>)
     }
  }
  
  case "ta":return(<div className="text-4xl zwichen"> ⵙⴰⵎⵃⴰⵜⴰⵙ ⵓⵔⵜⴰ ⵊⴰⵔⵓⵖ CV ⵙ ⵜⵎⴰⵣⵉⵖⵜ

   <Translate onSelected={SelectedLang}> </Translate> <Image > </Image> <Getkey onSubmit={creatKey}  /></div>
  )
    case "en":return(<div className="text-4xl"> sorry, my CV isn't ready in English yet.
    <Translate onSelected={SelectedLang}> </Translate> <Image > </Image> <Getkey onSubmit={creatKey} ></Getkey></div>)
      case "fr":return(<div className="text-4xl"> désolé, mon CV n'est pas encore prêt en français <Translate onSelected={SelectedLang}> </Translate> <Image > </Image> <Getkey onSubmit={creatKey}  /></div>)
        default: {
          if (isValid) {

            return(<div>
            
            <Image></Image>
                <Contact Headerkey={keyheader} land={lang} />
              <Ausbildung Headerkey={keyheader} lang={lang}/>
              <Berufstaetigkeit Headerkey={keyheader} lang={lang} />    
              <Kenntnisse Headerkey={keyheader} lang={lang} /> 
              <Praktikum Headerkey={keyheader} lang={lang} /> 
              <About  Headerkey={keyheader} lang={lang} />
              <Footer lang={lang}/> 
              
          </div>)
           }
           else{
             return(<div> <Translate onSelected={SelectedLang}> </Translate> <Image > </Image> <Getkey onSubmit={creatKey}  /></div>)
           }
          
        }
          
  
}





    
}
export default App;